import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import '@fortawesome/fontawesome-free/css/all.css'
import 'mdb-vue-ui-kit/css/mdb.min.css';
import '@fortawesome/fontawesome-free/js/all.js'
import './index.css'
import router from './router'
import VeeValidatePlugin from './plugins/validation'
import i18n from './i18n';
import { initSecurityMeasures } from './utils/security-utils';

initSecurityMeasures();

const app = createApp(App);

// Each plugin must be registered with its own app.use() call
app.use(VeeValidatePlugin);
app.use(VueAxios, axios);
app.use(router);
app.use(i18n);
app.mount('#app');